import React from 'react'
import { Box, Button } from '@mui/material'
import Download from '@mui/icons-material/Download'
import {
  DOWNLOAD_ACTION_TEXT_SX,
  getDownloadActionContentSx,
  getDownloadActionIconSize,
  getDownloadActionIconSlotSx,
  getDownloadCtaSx
} from './styles/downloadActionSx'

export default function DownloadActionButton({
  text = 'Descargar',
  onClick,
  type = 'button',
  disabled = false,
  density = 'card',
  fullWidth,
  sx: sxProp,
  endIcon,
  startIcon
}) {
  const resolvedFullWidth = fullWidth !== undefined ? fullWidth : density === 'card'
  const iconSize = getDownloadActionIconSize(density)
  const resolvedStartIcon =
    startIcon !== undefined ? startIcon : <Download sx={{ fontSize: iconSize }} />

  return (
    <Button
      variant="contained"
      disableElevation={false}
      type={type}
      disabled={disabled}
      onClick={onClick}
      fullWidth={resolvedFullWidth}
      sx={[getDownloadCtaSx({ density }), ...(sxProp ? [sxProp] : [])]}
    >
      <Box
        component="span"
        sx={getDownloadActionContentSx({ width: '85%' })}
      >
        <Box
          component="span"
          sx={getDownloadActionIconSlotSx({ density })}
        >
          {resolvedStartIcon}
        </Box>
        <Box component="span" sx={DOWNLOAD_ACTION_TEXT_SX}>
          {text}
        </Box>
        <Box
          component="span"
          sx={endIcon ? getDownloadActionIconSlotSx({ density }) : getDownloadActionIconSlotSx({ density, hidden: true })}
        >
          {endIcon || null}
        </Box>
      </Box>
    </Button>
  )
}
